import axios from 'axios';
import { HTTP_STATUS, HTTP_STATUS_MESSAGE } from '@/constant';
import toastr from 'toastr';

// シフトAPI用のbaseURLを決定する。
// 従来はサブドメイン（SHIFT_V2_API_BASE_URL: api-shift.codmon.com）でシフトAPIへ接続していたが、
// パスベースのディスカバリ（codmon.com/shift-management/api）へ移行中。
// リリース前のテスト用サブドメイン（otameshi / cf / oidc）でアクセスしている場合のみ、
// 現在のオリジンのパスベースURL（${origin}/shift-management/api）を使用する。
// テスト用サブドメイン廃止時にこの分岐は削除する。
// 段階リリースは manifest（beta_feature_rollouts の割合判定結果）の navigateShiftCf で制御する。
// シフトへの遷移と同じフラグを使うのは、遷移先と API 接続先を同じ利用者で揃えるため。
// 念のため try/catch で囲み、判定で例外が発生した場合は従来のサブドメインURLにフォールバックする。
function resolveShiftApiBaseUrl(): string {
  try {
    const hostname = window.location.hostname;
    const isPreReleaseTestSubdomain =
      hostname.startsWith('otameshi.') || hostname.startsWith('cf.') || hostname.startsWith('oidc.');
    if (isPreReleaseTestSubdomain) {
      return `${window.location.origin}/shift-management/api`;
    }
  } catch {
    // 判定に失敗した場合は従来のサブドメインURLにフォールバックする
  }

  if (window.CODMON_MANIFEST.features?.navigateShiftCf) {
    return `${window.location.origin}/shift-management/api`;
  }

  return `${window.CODMON_MANIFEST.urls.SHIFT_V2_API_BASE_URL}`;
}

const BASE_URL = resolveShiftApiBaseUrl();

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

// レスポンスがエラーの時に発火
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    let message = HTTP_STATUS_MESSAGE.DEFAULT;

    // { errorHandle: false }を設定することで、エラー処理を無視する
    if (error.config.data && JSON.parse(error.config.data).errorHandle === false) {
      return error.response;
    }

    const { status } = error.response;

    switch (status) {
      case HTTP_STATUS.FORBIDDEN:
        message = HTTP_STATUS_MESSAGE.FORBIDDEN;
        break;

      case HTTP_STATUS.NOT_FOUND:
        message = HTTP_STATUS_MESSAGE.NOT_FOUND;
        break;

      case HTTP_STATUS.LEGAL_REASONS:
        message = HTTP_STATUS_MESSAGE.LEGAL_REASONS;
        break;

      default:
        break;
    }

    toastr.options.closeButton = true;
    toastr.options.timeOut = 5000;
    toastr.options.toastClass = 'alert-danger2';

    toastr.error(message);

    //   notify({
    //     duration: 6000,
    //     position: 'right',
    //     message,
    //     classes: 'alert-danger2',
    //   });
    return Promise.reject(error);
  }
);

export default instance;
